import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
// import Button from "../../components/ui/Button.js";
// import ContactForm from "../../components/ui/ContactForm.js";
import { MdOutlineHome } from "react-icons/md";

const Sectors = () => {

  // const formRef = useRef(null);
  const history = useHistory();
  // const [activeTab, setActiveTab] = useState("Corporate Law");

  const handleClick = (field) => {
    history.push(field ? `/${field}` : "/");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleScrollToForm = () => {
  //   formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  // };


  return (
    <>
      <div className="overflow-hidden">


        <section className="bg-cover bg-no-repeat bg-right w-full h-auto" style={{ backgroundImage: `url('/assets/home/index-hero-section.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="">
                <div className="flex items-center font-medium text-base textcolor">
                  <MdOutlineHome size={24} className="mr-2 cursor-pointer" onClick={() => handleClick("")} />
                  <span className="mr-2 cursor-pointer" onClick={() => handleClick("expertise")}>/ Expertise</span>
                  <span>/ Ashish Ambasta</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#FFFFFF] md:py-16 py-8">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <div class="flex flex-col lg:flex-row gap-8">
              {/* <!-- Main Content --> */}
              <div class="lg:w-2/3">
                <h1 class="md:text-3xl text-2xl font-semibold mb-6">Automotive</h1>
                <img src="/assets/sectors/automotive-details.webp" alt="Automotive Sector" class="w-full mb-10" />

                <h1 class="textblack text-xl font-semibold mb-2">Expertise</h1>
                <p class="mb-4 text-gray-700">
                  Axiom has carved a niche in employment-related matters, particularly in advising companies
                  on how to build legally sound and people-positive workplaces. We now focus in:
                </p>

                <ul class="list-disc space-y-4 text-gray-700 pl-6">
                  <li className="">
                    <h1 className="textblack text-xl font-semibold">Organizational Policies</h1>
                    Designing and implementing HR policies, employment handbooks, POSH frameworks, codes of conduct,
                    and workplace governance mechanisms that align with Indian laws and global best practices.
                  </li>

                  <li className="">
                    <h1 className="textblack text-xl font-semibold">Labour & Industrial Disputes</h1><br />
                    Representing employers in industrial disputes, disciplinary inquiries, employee terminations,
                    conciliation proceedings, and labor court litigation. Axiom is known for its ability to achieve
                    settlements through strategic negotiation, while also being able to formalize defense when litigation
                    becomes necessary.
                  </li>

                  <li className="">
                    <h1 className="textblack text-xl font-semibold">Labour Law Compliance</h1><br />
                    Advising clients on compliance with India’s evolving labour law regime, including the new Labour Codes.
                    Drafting contracts, contract labour regulations, and wage structures, HR templates, contractor audits
                    and due diligence for mergers, acquisitions, or vendor compliance.
                  </li>
                </ul>

                <p class="mt-4 text-gray-700">
                  Axiom works closely with clients in the manufacturing, services, and logistics sectors, offering
                  sector-specific guidance that is crucial in region-sensitive matters. Whether helping clients
                  understand the pitfalls in fixed-term employment models, engaging with Trade Unions, or advising
                  on diversity policies—Axiom is ideally positioned to be the auto sector’s HR counsel.
                </p>

                <p class="mt-4 text-gray-700">
                  In addition to advisory, Axiom regularly appears before Labour Courts, Industrial Tribunals,
                  High Courts and other judicial forums to defend employer strategy. With a strong track record
                  in employment litigation, Axiom delivers legally effective strategies and helps HR teams navigate
                  real-time crisis, terminations, layoffs, disciplinary actions, etc.—consistently at the side of
                  HR, IR and business teams.
                </p>

                <p class="mt-4 text-gray-700">
                  Axiom is often retained by clients for its responsiveness, clarity of thought, and ability to
                  provide both preventive and real-time dispute solutions. Its commitment to law, business,
                  and people-centered strategies makes them a trusted advisor for HR leaders, in-house counsels,
                  and business owners.
                </p>
              </div>

              {/* <!-- Sidebar --> */}
              <aside class="lg:w-1/3 bg-[#F7F8FA] p-6 h-full">
                <h1 class="text-3xl font-semibold mb-4 textblack">Sectors</h1>
                <ul class="space-y-2 text-blue-900 font-medium">
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Agribusiness</li>
                  <li class="text-white px-4 py-3 rounded-md bg-[#003366]">Automotive</li>
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Consumer Goods & Retail</li>
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Education</li>
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Food and Beverages</li>
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Health Care & Life Sciences</li>
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Information Technology</li>
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Start-Ups</li>
                  <li class="hover:bg-[#003366] hover:text-white textblack cursor-pointer px-4 py-3 rounded-md bg-white">Textile Apparel & Accessories</li>
                </ul>
              </aside>
            </div>
          </div>
        </section>


        {/* <section ref={formRef} className="bg-cover bg-no-repeat md:py-16 py-8 bg-[#F7F8FA]">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 w-full">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 flex flex-col justify-center md:mb-0 pr-0 md:pr-10 md:pt-0 pt-4">
                  <div className="flex items-center justify-center w-full">
                    <img src="/assets/home/contact-us.webp" alt="Lead with Clarity" className="z-0" />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section> */}

        <Footer />
      </div>
    </>
  );
};


export default Sectors;
